<template>
  <template v-for="(part, i) in parts" :key="i">
    <mark v-if="part.match" class="search-hit">{{ part.text }}</mark>
    <template v-else>{{ part.text }}</template>
  </template>
</template>

<script setup>
// Marks every case-insensitive occurrence of `query` in `text`, so a result
// shows why it matched ("book" inside "Notebook"). Renders text nodes and
// <mark> only — no v-html — so tender data can't inject markup.
import { computed } from "vue";

const props = defineProps({
  text:  { type: [String, Number], default: "" },
  query: { type: String, default: "" },
});

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const parts = computed(() => {
  const text = props.text == null ? "" : String(props.text);
  // The backend matches the whole trimmed phrase (LIKE %phrase%), so the
  // whole phrase is what gets marked.
  const q = (props.query || "").trim();
  if (!q || !text) return [{ text, match: false }];
  const lower = q.toLowerCase();
  return text
    .split(new RegExp(`(${escapeRegExp(q)})`, "gi"))
    .filter((t) => t !== "")
    .map((t) => ({ text: t, match: t.toLowerCase() === lower }));
});
</script>

<style scoped>
/* Classic yellow search highlight (yellow-200). Kept apart from amber, which
   already means "closing soon" on these screens. The matched text goes dark
   (#0f172a, 15:1) because grey secondary text such as the organisation
   (#64748b) is only 4.2:1 on the yellow. */
.search-hit {
  background: #fef08a;
  color: #0f172a;
  border-radius: 4px;
  padding: 0 1px;
}
</style>
